import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Oval } from "../../assets/imagesPath";
import { useForm } from "react-hook-form";
import Dropdown from "../../assets/icons/Dropdown";
import { useNavigate } from "react-router-dom";
import PATHS from "../../routes/Paths";
import { useDispatch, useSelector } from "react-redux";
import { updateBusinessForm } from "../../redux/AuthSlice";

const BusinessDetail = () => {

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isSubmenuOpen, setIsSubmenuOpen] = useState(null);
    const [taxStatus, setTaxStatus] = useState("");
    const [oprAgreement, setOprAgreement] = useState("");
    const [members, setMembers] = useState("");
    const [employees, setEmployees] = useState("");
    const [annRevenue, setAnnRevenue] = useState("");
    const [bGoal, setbGoal] = useState("");
    const [enableTabs, setEnableTabs] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((data) => data?.auth);
    const formData = auth?.businessDetailForm;

    const customStyles = {
        control: (base) => ({
            ...base,
            backgroundColor: "white",
            border: "1px solid #ddd",
            borderRadius: "10px",
            padding: "5px",
            fontSize: "1.2rem",
            cursor: "pointer",

        }),
        menu: (base) => ({
            ...base,
            backgroundColor: "#173363",
            borderRadius: "4px",
        }),
        menuList: (provided) => ({ ...provided, paddingTop: 0, paddingBottom: 0, }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? "white" : "#173363",
            color: state.isFocused ? "#173363" : "white",
            cursor: "pointer",
            fontSize: "1.2rem",
            // padding: "8px",
            borderRadius: "4px",
        }),
        indicatorSeparator: () => ({
            display: "none",
        }),
        singleValue: (base) => ({
            ...base,
            color: "black",
            fontSize: "1.6rem",
        }),
    };
    const options = [
        { label: "Select", value: "Select" },
        { label: "Not yet formed", value: "Not yet formed" },
        { label: "Sole Proprietorship", value: "Sole Proprietorship" },
        { label: "General Partnership", value: "General Partnership" },
        { label: "Limited Partnership (LP)", value: "Limited Partnership (LP)" },
        {
            label: "Others",
            submenu: [
                { label: "Limited Liability Partnership (LLP)", value: "Limited Liability Partnership (LLP)" },
                { label: "Single-Member LLC (SMLLC)", value: "Single-Member LLC (SMLLC)" },
                { label: "Limited Partnership (LP)", value: "Limited Partnership (LP)" },
                { label: "Multi-Member LLC (MMLLC)", value: "Multi-Member LLC (MMLLC)" },
                { label: "I don't Know", value: "I don't Know" }
            ],
        },
    ];

    const options2 = [
        { value: '', label: 'Select' },
        { value: 'YES', label: 'Yes' },
        { value: 'NO', label: 'No' },
        { value: 'NOT_SURE', label: 'Not Sure' },
    ];
    const options3 = [
        { value: '', label: 'Select' },
        { value: '1 - 10', label: '1 - 10' },
        { value: '11 - 20', label: '11 - 20' },
        { value: '21 - 50', label: '21 - 50' },
        { value: '51 - 100', label: '51 - 100' },
        { value: 'NOT_SURE', label: 'Not Sure' },
    ];

    const revenueOptions = [
        { value: '', label: 'Select' },
        { value: 'Under $100,000', label: 'Under $100,000' },
        { value: '$100,000 - $250,000', label: '$100,000 - $250,000' },
        { value: '$250,001 - $500,000', label: '$250,001 - $500,000' },
        { value: 'More than $500,000', label: 'More than $500,000' },
    ];


    const handleOptionClick = (value) => {
        setSelectedOption(value);
        setIsDropdownOpen(false);
    };

    const {
        setError,
        clearErrors,
        formState: { errors },
    } = useForm();

    const onSubmit = () => {

        const data = {
            businessDetails: {
                businessStructure: selectedOption,
                llcType: "Single Member",
                sCorpElection: taxStatus,
                hasOperatingAgreement: oprAgreement,
                numberOfMembers: Number(members?.length ?? 0),
                numberOfEmployees: employees,
                annualRevenue: annRevenue,
                primaryBusinessGoal: bGoal,
            },
        };
        // console.log("tax status", data, taxStatus)

        dispatch(updateBusinessForm(data));
        navigate(PATHS.servicesNeeded);
    };

    const validationHandler = () => {
        let noError = false;

        selectedOptionValidationHandler();
        taxStatusValidationHandler();
        oprAgreementValidationHandler();
        membersValidationHandler();
        employeesValidationHandler();
        annRevenueValidationHandler();
        bGoalValidationHandler();

        if (selectedOption && taxStatus && oprAgreement && members && employees && annRevenue && bGoal) {
            onSubmit();
            setEnableTabs(true);
        } else {
            return false;
        }

        return noError;
    };

    const selectedOptionValidationHandler = () => {
        if (!selectedOption) {
            setError("bStructure", { type: "custom", message: "Option is required" });
        } else {
            clearErrors("bStructure");
        }
    };

    const taxStatusValidationHandler = () => {
        if (!taxStatus) {
            setError("taxStatus", { type: "custom", message: "Option is required" });
        } else {
            clearErrors("taxStatus");
        }
    };

    const oprAgreementValidationHandler = () => {
        if (!oprAgreement) {
            setError("oprAgreement", { type: "custom", message: "Option is required" });
        } else {
            clearErrors("oprAgreement");
        }
    };

    const membersValidationHandler = () => {
        if (!members) {
            setError("members", { type: "custom", message: "Option is required" });
        } else {
            clearErrors("members");
        }
    };

    const employeesValidationHandler = () => {
        if (!employees) {
            setError("employees", { type: "custom", message: "Option is required" });
        } else {
            clearErrors("employees");
        }
    };

    const annRevenueValidationHandler = () => {
        if (!annRevenue) {
            setError("annRevenue", { type: "custom", message: "Option is required" });
        } else {
            clearErrors("annRevenue");
        }
    };

    const bGoalValidationHandler = () => {
        if (!bGoal) {
            setError("bGoal", { type: "custom", message: "Goal is required" });
        } else {
            clearErrors("bGoal");
        }
    };

    useEffect(() => {
        if (formData?.businessDetails) {
            let { businessStructure, sCorpElection, hasOperatingAgreement, numberOfMembers, numberOfEmployees, annualRevenue, primaryBusinessGoal } = formData?.businessDetails;
            setSelectedOption(businessStructure);
            setTaxStatus(sCorpElection);
            setOprAgreement(hasOperatingAgreement);
            setMembers(numberOfMembers);
            setEmployees(numberOfEmployees);
            setAnnRevenue(annualRevenue);
            setbGoal(primaryBusinessGoal);
        }
    }, [formData?.businessDetails]);

    useEffect(() => {
        if (selectedOption?.length) clearErrors("bStructure");
        if (taxStatus) clearErrors("taxStatus");
        if (oprAgreement) clearErrors("oprAgreement");
        if (members) clearErrors("members");
        if (employees) clearErrors("employees");
        if (annRevenue) clearErrors("annRevenue");
        if (bGoal) clearErrors("bGoal");
    }, [selectedOption?.length, taxStatus, oprAgreement, members, employees, annRevenue, bGoal, clearErrors]);

    return (
        <div className="w-full mb-16">


            <div className="mx-auto text-center mb-10 space-x-4 space-y-4 mt-40 tabsBtn">
                <button
                    className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
                    onClick={() => navigate(PATHS.basicInfo)}
                >
                    Basic Infomation
                </button>
                <button
                    className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#173363] text-[#FFFFFF] border border-[#8188918C]"
                    onClick={() => navigate(PATHS.businessDetails)}
                >
                    Business Details
                </button>
                <button
                    className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
                    onClick={() => navigate(PATHS.servicesNeeded)}
                    disabled={!enableTabs}
                >
                    Services Needed
                </button>
                <button
                    className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
                    onClick={() => navigate(PATHS.clientScreening)}
                    disabled={!enableTabs}
                >
                    Client Screening Questions
                </button>
                <button
                    className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
                    onClick={() => navigate(PATHS.businessFormation)}
                    disabled={!enableTabs}
                >
                    Business Formation Decision
                </button>
                <button
                    className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
                    onClick={() => navigate(PATHS.additionalDetails)}
                    disabled={!enableTabs}
                >
                    Additional Details
                </button>
            </div>

            <div className="flex justify-center items-center p-16 pb-40 min-h-[50vh]">
                <div className="w-3/4 smallScreens:w-full bg-white mt-20 shadow-2xl rounded-xl p-10 md:p-14 relative">
                    {/* <div className="text-[2.4rem] text-[#121212] text-center mb-20 font-extrabold">Business Details</div> */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div>
                            <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium mediumScreens:text-[1.2rem]">
                                What is your current business structure?
                            </label>
                            <div className="relative mt-4">
                                <div
                                    className="w-full flex py-4 px-5 border rounded-xl fix_height_input text-2xl font-normal text-[#3f3e3e] bg-white cursor-pointer"
                                    onClick={() => setIsDropdownOpen((prev) => !prev)}
                                >
                                    {selectedOption || "Select"}
                                    <span className="absolute inset-y-0 right-5 flex items-center pointer-events-none">
                                        <Dropdown />
                                    </span>
                                </div>
                                {isDropdownOpen && (
                                    <div className="absolute  mt-4 bg-[#173363] text-white border text-xl rounded-xl shadow-lg w-full z-10">
                                        {options?.map((option, index) => (
                                            <div key={index}>
                                                <div
                                                    className={`py-3 px-4 hover:bg-white hover:text-[#173363] cursor-pointer rounded-lg ${option.submenu ? "flex justify-between" : ""
                                                        }`}
                                                    onClick={() =>
                                                        option.submenu
                                                            ? setIsSubmenuOpen(isSubmenuOpen === index ? null : index)
                                                            : handleOptionClick(option.value)
                                                    }
                                                >
                                                    {option.label}
                                                    {option.submenu && (
                                                        <span className="ml-2 text-gray-500">
                                                            <Dropdown />
                                                        </span>
                                                    )}
                                                </div>
                                                {option?.submenu && isSubmenuOpen === index && (
                                                    <div>
                                                        {option.submenu?.map((subOption, subIndex) => (
                                                            <div
                                                                key={subIndex}
                                                                className="py-3 px-4 hover:bg-white hover:text-[#173363] cursor-pointer rounded-lg"
                                                                onClick={() => handleOptionClick(subOption.value)}
                                                            >
                                                                {subOption.label}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            {errors.bStructure && (
                                <p className="text-red-500 text-[1.2rem] mt-1">{errors.bStructure.message}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium mediumScreens:text-[1.2rem]">
                                Do you plan to elect S Corporation tax status?
                            </label>
                            <div className="relative mt-4">
                                <Select
                                    options={options2}
                                    value={options2?.find((option) => option.value === taxStatus)}
                                    onChange={(selectedOption) => setTaxStatus(selectedOption.value)}
                                    placeholder="Select"
                                    styles={customStyles}
                                    className="fix_height_input"
                                />
                            </div>
                            {errors.taxStatus && (
                                <p className="text-red-500 text-[1.2rem] mt-1">{errors.taxStatus.message}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium mediumScreens:text-[1.2rem]">
                                Do you currently have an Operating Agreement?
                            </label>
                            <Select
                                options={options2}
                                value={options2?.find((option) => option.value === oprAgreement)}
                                onChange={(selectedOption) => setOprAgreement(selectedOption.value)}
                                placeholder="Select"
                                styles={customStyles}
                                className="fix_height_input"
                            />
                            {/* <div className="relative mt-4">
                                <Select
                                    options={options2}
                                    styles={customStyles}
                                    onChange={handleOpr}
                                    value={oprAgreement}
                                    placeholder="Select"
                                />

                                <span className="absolute inset-y-0 right-5 flex items-center pointer-events-none">
                                    <Dropdown />
                                </span>
                            </div> */}
                            {errors.oprAgreement && (
                                <p className="text-red-500 text-[1.2rem] mt-1">{errors.oprAgreement.message}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium mediumScreens:text-[1.2rem]">
                                How many members does your LLC have?
                            </label>
                            <input
                                type="number"
                                placeholder="Enter Here"
                                className="w-full fix_height_input text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-2xl focus:outline-none"
                                onChange={(e) => setMembers(e.target.value)}
                                value={members}
                            />
                            {errors.members && (
                                <p className="text-red-500 text-[1.2rem] mt-1">{errors.members.message}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium mediumScreens:text-[1.2rem]">
                                How many employees (including yourself) do you currently have?
                            </label>
                            <div className="relative mt-4">
                                {/* <select
                                    className="appearance-none w-full py-5 px-5 border rounded-xl focus:outline-none text-2xl font-normal text-[#757575]"
                                    onChange={(e) => setEmployees(e.target.value)}
                                    value={employees}
                                >
                                    <option value="">Select</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5 or fewer">5 or fewer</option>
                                    <option value="More than 5">More than 5</option>
                                </select> */}
                                <Select
                                    options={options3}
                                    value={options3?.find((option) => option.value === employees)}
                                    onChange={(selectedOption) => setEmployees(selectedOption.value)}
                                    placeholder="Select"
                                    styles={customStyles}
                                    className="fix_height_input"
                                />
                            </div>
                            {errors.employees && (
                                <p className="text-red-500 text-[1.2rem] mt-1">{errors.employees.message}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium mediumScreens:text-[1.2rem]">
                                What is your annual revenue or expected annual revenue?
                            </label>
                            <div className="relative mt-4">
                                <Select
                                    options={revenueOptions}
                                    value={options2?.find((option) => option.value === annRevenue)}
                                    onChange={(selectedOption) => {

                                        setAnnRevenue(selectedOption.value)
                                    }}
                                    placeholder="Select"
                                    styles={customStyles}
                                    className="fix_height_input"
                                />
                            </div>
                            {errors.annRevenue && (
                                <p className="text-red-500 text-[1.2rem] mt-1">{errors.annRevenue.message}</p>
                            )}
                        </div>

                    </div>
                    <div>
                        <label className="block text-[1.4rem] my-3 text-[#000000] font-medium mediumScreens:text-[1.2rem]">
                            Primary Business Goal
                        </label>
                        <input
                            type="text"
                            placeholder="Enter Here"
                            className="w-full fix_height_input text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-2xl focus:outline-none"
                            onChange={(e) => setbGoal(e.target.value)}
                            value={bGoal}
                        />
                        {errors.bGoal && (
                            <p className="text-red-500 text-[1.2rem] mt-1">{errors.bGoal.message}</p>
                        )}
                    </div>
                    <div className="text-center my-6">
                        <button
                            type="button"
                            className="w-2/3 text-[1.6rem] bg-[#173363] text-white py-4 rounded-lg"
                            onClick={validationHandler}
                            // disabled={employees == 'More than 5' || annRevenue == 'More than $500,000'}
                        >
                            Save
                        </button>
                    </div>

                    <div className="absolute -top-20 -right-20 h-[10rem] w-[10rem] z-[-1]">
                        <img src={Oval} alt="oval-img" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BusinessDetail;



